import { render, staticRenderFns } from "./Seniors.vue?vue&type=template&id=77458242&"
import script from "./Seniors.vue?vue&type=script&lang=js&"
export * from "./Seniors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports